import {GameStore} from "./features/game/game-store";

// Tutorial hints, shown in the HUD (was a jQuery #system-message banner in the GAE version).
let System = {
    DisplayMessage : function(message:any){
        GameStore.set({hint: String(message)});
    },
    ClearMessage : function(){
        GameStore.set({hint: null});
    }
};

export default System;
